export * from '@taqueria/protocol/out/types/Config';
